<template>
  <v-container fluid fill-height>
    <component v-on:changeView="oncChangeView" v-bind:is="componentName" :show="show"></component>
  </v-container>
</template>

<script>
import Login from '../components/Login'
import ForgotPassword from '../components/ForgotPassword'

export default {
  data () {
    return {
      componentName: 'Login',
      show: false
    }
  },
  components: {
    Login,
    ForgotPassword
  },
  created () {
    this.$store.commit('hideNavigation')
    if (window.innerWidth >= 600) {
      this.show = true
    }

    if (this.$route.query.cmp && (this.$route.query.cmp === 'log' || this.$route.query.cmp === 'fp')) {
      this.componentName = this.$route.query.cmp === 'log' ? 'Login' : 'ForgotPassword'
    }
  },
  methods: {
    oncChangeView: function (value) {
      this.componentName = value
    }
  }
}
</script>
